// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"a986a905","527":"87f55f40","877":"dee39f5e","935":"c8cb7f62"}[chunkId] + ".chunk.css";
};